import { Colors } from "@/enums/Colors";
import { BoxProps } from "@mui/material";
import { Box, styled } from "@mui/system";

const globalStyles = `
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: "4rem",
  height: "2rem",
  gap: ".5rem",
  justifyContent: "center",
}));

const Dot = styled(Box)(({ theme }) => ({
  width: ".5rem",
  height: ".5rem",
  borderRadius: "50%",
  animation: "pulse 1.5s infinite",
}));

interface Props {
  points: number;
  pointsColor?: string;
  containerProps?: BoxProps;
}

const PointsWaveAnimation = ({ points, pointsColor, containerProps }: Props) => {
  const delay = Array.from({ length: points }, (_, index) => `${index * 0.5}s`);

  return (
    <>
      <style>{globalStyles}</style>
      <Container {...containerProps}>
        {Array.from({ length: points }, (_, index) => (
          <Dot
            key={index}
            sx={{
              animationDelay: delay[index],
              backgroundColor: pointsColor ?? Colors.LAZO_LIGHT_PURPLE_TEXT,
            }}
          />
        ))}
      </Container>
    </>
  );
};

export default PointsWaveAnimation;
